import request from '@/utils/request';

// 验证码
export const captchaKey = Date.now();
export const captchaLink = () => {
  return `/api/common/captcha/gen?key=${captchaKey}`;
};

// 登录
export const loginApi = (data) => {
  return request({
    url: '/admin/sys/user/encryptLogin',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json'
    },
    data
  });
};

// 左侧菜单
export const slidbarApi = (params) => {
  return request({
    url: '/admin/sys/menu/routes',
    method: 'get',
    params
  });
};
